const t = "_root_6tojq_1", o = "_skeletonCellRoot_6tojq_1", e = "_center_6tojq_10", _ = "_left_6tojq_13", l = "_right_6tojq_16", n = {
  root: t,
  skeletonCellRoot: o,
  center: e,
  left: _,
  right: l
};
export {
  e as center,
  n as default,
  _ as left,
  l as right,
  t as root,
  o as skeletonCellRoot
};
//# sourceMappingURL=index.es743.js.map
